import { render } from "./FormAuthComp.vue?vue&type=template&id=a8aac6a6&scoped=true"
import script from "./FormAuthComp.vue?vue&type=script&lang=js"
export * from "./FormAuthComp.vue?vue&type=script&lang=js"

import "./FormAuthComp.vue?vue&type=style&index=0&id=a8aac6a6&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8aac6a6"]])

export default __exports__